"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HighlightText = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var react_1 = __importDefault(require("react"));
var react_jss_1 = require("react-jss");
var useHighlightTextStyles = (0, react_jss_1.createUseStyles)({
    span: {
        fontWeight: 400,
    },
});
var reservedChars = "\\^$.|?*+()[{";
var buildRegex = function (keyword) {
    // Replace all regex reserved chars
    var pattern = keyword
        ? keyword
            .split("")
            .map(function (character) { return "".concat(reservedChars.includes(character) ? "\\" : "").concat(character); })
            .join("")
        : "";
    return new RegExp("(".concat(pattern, ")"), "gi");
};
var HighlightText = function (props) {
    var baseColor = props.baseColor, highlightColor = props.highlightColor, label = props.label, keyword = props.keyword;
    var classes = useHighlightTextStyles();
    var pattern = buildRegex(keyword);
    var labelStr = new String(label);
    var splitLabel = labelStr ? labelStr.split(pattern).filter(function (labelPart) { return labelPart.length > 0; }) : [];
    var spans = splitLabel.map(function (labelPart, index) {
        var color = labelPart && keyword && labelPart.toLowerCase() === keyword.toLowerCase() ? highlightColor : baseColor;
        return (react_1.default.createElement("span", { className: classes.span, key: index, style: { color: color } }, labelPart));
    });
    return react_1.default.createElement(react_1.default.Fragment, null, spans);
};
exports.HighlightText = HighlightText;
exports.HighlightText.displayName = "HighlightText";
//# sourceMappingURL=HighlightText.js.map